import { styled } from '@mui/material';

export const ToggleContainer = styled('label')(() => ({
  cursor: 'pointer',

  '> input': {
    display: 'none',
  },

  '> input + div': {
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    position: 'relative',
    boxShadow: `inset 11px -11px 0 0 #E6D9CA`,
    transform: 'scale(1) rotate(-2deg);',
    transition: 'box-shadow 0.5s ease 0s, transform 0.4s ease 0.1s',
  },

  '> input + div::before': {
    content: '""',
    borderRadius: 'inherit',
    width: 'inherit',
    height: 'inherit',
    position: 'absolute',
    transition: 'background 0.3s ease',
    left: 0,
    top: 0,
  },

  '> input + div::after': {
    content: '""',
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    position: 'absolute',
    left: '50%',
    top: '50%',
    margin: '-3px 0 0 -3px',
    transform: 'scale(0)',
    transition: 'all 0.3s ease',
    boxShadow: `0 -15px 0 #805a3c,  0 15px 0 #805a3c,
  15px 0 0 #805a3c,
  -15px 0 0 #805a3c,
  10px 10px 0 #805a3c,
  -10px 10px 0 #805a3c,
  10px -10px 0 #805a3c,
  -10px -10px 0 #805a3c`,
  },

  '> input:checked + div': {
    boxShadow: 'inset 20px -20px 0 0 #fff',
    transform: 'scale(0.5) rotate(0deg)',
    transition: 'transform 0.3s ease 0.1s, box-shadow 0.2s ease 0s',
  },

  '> input:checked + div::before': {
    background: '#805a3c',
    transition: 'background 0.3s ease 0.1s',
  },

  '> input:checked + div::after': {
    transform: 'scale(1.5)',
    transition: 'transform 0.5s ease 0.15s',
  },
}));
